import {Emoji} from 'Event/Dashboard/components/EmojiList/emoji'
import CLAP_IMAGE from 'Event/Dashboard/components/EmojiList/emoji/clap.png'
import HEART_IMAGE from 'Event/Dashboard/components/EmojiList/emoji/heart.png'
import LAUGH_IMAGE from 'Event/Dashboard/components/EmojiList/emoji/laugh.png'
import THUMB_UP_IMAGE from 'Event/Dashboard/components/EmojiList/emoji/thumbup.png'
import THUNDER_IMAGE from 'Event/Dashboard/components/EmojiList/emoji/thunder.png'

export const EmojiesList: Record<string, Emoji> = {
  HEART: {
    name: 'heart',
    image: HEART_IMAGE,
  },
  THUMB_UP: {
    name: 'thumb_up',
    image: THUMB_UP_IMAGE,
  },
  THUNDER: {
    name: 'thunder',
    image: THUNDER_IMAGE,
  },
  CLAP: {
    name: 'clap',
    image: CLAP_IMAGE,
  },
  LAUGH: {
    name: 'laugh',
    image: LAUGH_IMAGE,
  },
  LAUGH2: {name: 'laugh', icon: '😂'},
  ROFL: {name: 'rofl', icon: '🤣'},
  TEARS: {name: 'tears', icon: '😭'},
  SMILE: {name: 'smile', icon: '😊'},
  GRIN: {name: 'grin', icon: '😁'},
  BLUSH: {name: 'blush', icon: '☺️'},
  WINK: {name: 'wink', icon: '😉'},
  THINK: {name: 'think', icon: '🤔'},
  MELT: {name: 'melt', icon: '🥹'},
  STARSTRUCK: {name: 'starstruck', icon: '🤩'},
  COOL: {name: 'cool', icon: '😎'},
  FACEPALM: {name: 'facepalm', icon: '🤦'},
  SHOCK: {name: 'shock', icon: '😱'},
  SLEEPY: {name: 'sleepy', icon: '😴'},
  HUG: {name: 'hug', icon: '🤗'},
  KISS: {name: 'kiss', icon: '😘'},
  HEART_EYES: {name: 'heart_eyes', icon: '😍'},
  SWEAT: {name: 'sweat', icon: '😅'},
  ANGRY: {name: 'angry', icon: '😡'},
  SKULL: {name: 'skull', icon: '💀'},

  // Hearts & Love
  HEART2: {name: 'heart', icon: '❤️'},
  BLUE_HEART: {name: 'blue_heart', icon: '💙'},
  GREEN_HEART: {name: 'green_heart', icon: '💚'},
  YELLOW_HEART: {name: 'yellow_heart', icon: '💛'},
  PURPLE_HEART: {name: 'purple_heart', icon: '💜'},
  BLACK_HEART: {name: 'black_heart', icon: '🖤'},
  ORANGE_HEART: {name: 'orange_heart', icon: '🧡'},
  PINK_HEART: {name: 'pink_heart', icon: '🩷'},
  HEART_HANDS: {name: 'heart_hands', icon: '🫶'},
  BROKEN_HEART: {name: 'broken_heart', icon: '💔'},

  // Gestures
  CLAP2: {name: 'clap', icon: '👏'},
  FLEX: {name: 'flex', icon: '💪'},
  PRAY: {name: 'pray', icon: '🙏'},
  WAVE: {name: 'wave', icon: '👋'},
  THUMBS_UP: {name: 'thumbs_up', icon: '👍'},
  THUMBS_DOWN: {name: 'thumbs_down', icon: '👎'},
  OK: {name: 'ok', icon: '👌'},
  PEACE: {name: 'peace', icon: '✌️'},
  POINT_UP: {name: 'point_up', icon: '☝️'},
  POINT_RIGHT: {name: 'point_right', icon: '👉'},
  POINT_LEFT: {name: 'point_left', icon: '👈'},
  POINT_DOWN: {name: 'point_down', icon: '👇'},

  // Symbols & Objects
  FIRE: {name: 'fire', icon: '🔥'},
  STAR: {name: 'star', icon: '✨'},
  HUNDRED: {name: 'hundred', icon: '💯'},
  CHECK: {name: 'check', icon: '✔️'},
  CROSS: {name: 'cross', icon: '❌'},
  QUESTION: {name: 'question', icon: '❓'},
  EXCLAMATION: {name: 'exclamation', icon: '❗'},
  ALERT: {name: 'alert', icon: '🚨'},
  WARNING: {name: 'warning', icon: '⚠️'},
  PARTY: {name: 'party', icon: '🥳'},
  BALLOON: {name: 'balloon', icon: '🎈'},
  GIFT: {name: 'gift', icon: '🎁'},
  MUSIC: {name: 'music', icon: '🎶'},
  CAMERA: {name: 'camera', icon: '📸'},
  PHONE: {name: 'phone', icon: '📱'},
  COMPUTER: {name: 'computer', icon: '💻'},
  GAME: {name: 'game', icon: '🎮'},
  MONEY: {name: 'money', icon: '💸'},
  TROPHY: {name: 'trophy', icon: '🏆'},

  // Food & Drink
  PIZZA: {name: 'pizza', icon: '🍕'},
  BURGER: {name: 'burger', icon: '🍔'},
  FRIES: {name: 'fries', icon: '🍟'},
  ICECREAM: {name: 'icecream', icon: '🍦'},
  CAKE: {name: 'cake', icon: '🎂'},
  COFFEE: {name: 'coffee', icon: '☕'},
  BEER: {name: 'beer', icon: '🍺'},
  WINE: {name: 'wine', icon: '🍷'},
  COCKTAIL: {name: 'cocktail', icon: '🍹'},

  // Animals & Nature
  DOG: {name: 'dog', icon: '🐶'},
  CAT: {name: 'cat', icon: '🐱'},
  PANDA: {name: 'panda', icon: '🐼'},
  MONKEY: {name: 'monkey', icon: '🐵'},
  LION: {name: 'lion', icon: '🦁'},
  TIGER: {name: 'tiger', icon: '🐯'},
  BEAR: {name: 'bear', icon: '🐻'},
  FOX: {name: 'fox', icon: '🦊'},
  RABBIT: {name: 'rabbit', icon: '🐰'},
  UNICORN: {name: 'unicorn', icon: '🦄'},
  SUN: {name: 'sun', icon: '☀️'},
  MOON: {name: 'moon', icon: '🌙'},
  CLOUD: {name: 'cloud', icon: '☁️'},
  RAINBOW: {name: 'rainbow', icon: '🌈'},
  FLOWER: {name: 'flower', icon: '🌸'},
  TREE: {name: 'tree', icon: '🌳'},
  LEAF: {name: 'leaf', icon: '🍃'},

  // Travel & Places
  CAR: {name: 'car', icon: '🚗'},
  BUS: {name: 'bus', icon: '🚌'},
  TRAIN: {name: 'train', icon: '🚆'},
  PLANE: {name: 'plane', icon: '✈️'},
  ROCKET: {name: 'rocket', icon: '🚀'},
  EARTH: {name: 'earth', icon: '🌍'},
  MAP: {name: 'map', icon: '🗺️'},
  BEACH: {name: 'beach', icon: '🏖️'},
  MOUNTAIN: {name: 'mountain', icon: '⛰️'},
  CITY: {name: 'city', icon: '🏙️'},
}
